import axios from 'axios';
import { url } from '../utils/constants';
import { formatDate } from '../utils/helpers';

// Form
async function callCodeBehind(methodName, methodParams = {}) {
  let res;
  let data = null;
  try {
    res = await axios.post(`${url}/${methodName}`, methodParams);
    if (res.status == 200) {
      data = res.data.d;
    }
  } catch (error) {
    console.error(methodName, error);
  }

  return data;
}

export async function getContactRelation() {
  return await callCodeBehind('GetContactRelaction');
}

export async function getOptions() {
  const res = await axios.post(`${url}/GetOptions`, {});

  if (res.status == 200) {
    return res.data.d;
  }

  return null;
}

// Axa
export async function getDTO() {
  const res = await axios.post(`${url}/GetDTO`, {});

  if (res.status == 200) {
    return res.data.d;
  }

  return null;
}

export async function GetPolicies(policyNumber, cpf, date) {
  return await callCodeBehind('GetPoliciesByNumberOrCpf', {
    policyNumber,
    cpf,
    date,
    // ramos,
  });
}

export async function getRiskUnits(operationPK) {
  const res = await callCodeBehind('GetRiskUnits', {
    operationPK,
  });
  return res.RiskUnits;
}

export async function getInsuranceObjects(operationPK, riskUnitId) {
  const res = await callCodeBehind('GetInsuranceObjects', {
    operationPK,
    riskUnitId,
  });
  return res.InsuranceObjects;
}

export async function getInsuranceObjectDetails(
  damageId,
  templateId,
  symbolFilters
) {
  return await callCodeBehind('GetInsuranceObjectDetails', {
    damageId,
    templateId,
    symbolFilters,
  });
}

export async function getCoverages(operationPK, insuranceObjectId) {
  const res = await callCodeBehind('GetCoverages', {
    operationPK,
    insuranceObjectId,
  });
  return res.Coverages;
}

export async function getCoverageDetail(operationPK, coverageId) {
  return await callCodeBehind('GetCoverageDetail', {
    operationPK,
    coverageId,
  });
}

// export async function getAllCoverageDetails(allCoverageDetails) {
//   return await callCodeBehind('GetAllCoverageDetails', {
//     allCoverageDetails,
//   });
// }

export async function getEvents(apoliceProdutoId, apoliceCoberturaId, ramoId) {
  return await callCodeBehind('GetEvents', {
    apoliceProdutoId,
    apoliceCoberturaId,
    ramoId,
  });
}

export async function getEventsByProductId(apoliceProdutoId) {
  return await callCodeBehind('GetEventsByProductId', {
    apoliceProdutoId,
  });
}

export async function getPeriodoDia() {
  return await callCodeBehind('GetPeriodoDia');
}

export async function getBPO(gdmTipoId) {
  return await callCodeBehind('GetBPO', { gdmTipoId });
}

export async function getCepInfo(cep) {
  return await callCodeBehind('GetCepInfo', { cep });
}

export async function getAllCountries() {
  return await callCodeBehind('GetPaises');
}

export async function getDistricts() {
  return await callCodeBehind('GetDistritos');
}

export async function getCities(districtoId) {
  return await callCodeBehind('GetCidades', {
    districtoId,
  });
}

export async function getParish(concelhoId) {
  return await callCodeBehind('GetBairros', {
    concelhoId,
  });
}

export async function getFormDataByApoliceProdutoIdAndBranchId(
  apoliceProdutoId,
  apoliceCoberturaId
) {
  return await callCodeBehind('GetFormDataByApoliceProdutoId', {
    apoliceProdutoId,
    apoliceCoberturaId,
  });
}

export async function getGDMCategoria() {
  return await callCodeBehind('GetGDMCategoria');
}

export async function getGDMTipo() {
  return await callCodeBehind('GetGDMTipo');
}

export async function getGDMTipoByCategoria(categoriaId) {
  return await callCodeBehind('GetGDMTipoByCategoria', { categoriaId });
}

export async function getGDMTiposFiltro(productSettingCode) {
  return await callCodeBehind('GetGDMTipos', { productSettingCode });
}

export async function getPBOs(product) {
  const res = await callCodeBehind('GetBPOs', { product });

  return res.BPOs;
}

// async function getCoveragesToDTO(dto, coverages){

// }

export async function createAviso(dto, coverages) {
  // Preencher array coberturas
  
  for (const cov of coverages) {
    const res = await getCoverageDetail(
      dto.Apolice.ApoliceContrato,
      cov.CoverageId
    );
    const inicioData = formatDate(
      parseInt(res.ApoliceCoberturaDataInicio.substr(6))
    );
    const fimData = formatDate(parseInt(res.ApoliceCoberturaDataFim.substr(6)));

    dto.Coberturas.push({
      CoberturaId: cov.GisCoverageId,
      Franquia: res.Franquia,
      CapitalSeguro: res.CapitalSeguro,
      ReservaObs: res.ReservaObs,
      ApoliceCoberturaDataInicio: inicioData,
      ApoliceCoberturaDataFim: fimData,
    });
  }

  // const inputGetCoverageDetails = coverages.map((c) => {
  //   return {
  //     OperationPk: dto.Apolice.ApoliceContrato,
  //     CoverageId: c.CoverageId,
  //   };
  // });

  // const allCoverageDetails = await getAllCoverageDetails(
  //   inputGetCoverageDetails
  // );

  // for (const cov of allCoverageDetails) {
  //   const inicioData = formatDate(
  //     parseInt(cov.ApoliceCoberturaDataInicio.substr(6))
  //   );
  //   const fimData = formatDate(parseInt(cov.ApoliceCoberturaDataFim.substr(6)));

  //   dto.Coberturas.push({
  //     CoberturaId: cov.CoberturaId,
  //     Franquia: cov.Franquia,
  //     CapitalSeguro: cov.CapitalSeguro,
  //     ReservaObs: cov.ReservaObs,
  //     ApoliceCoberturaDataInicio: inicioData,
  //     ApoliceCoberturaDataFim: fimData,
  //   });
  // }

  return await callCodeBehind('PostAberturaAviso', { aberturaAvisoDTO: dto });
}
